import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";

import {
  Checkbox,
  Collapse,
  TableCell,
  TableRow,
  Button,
  MenuItem,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import queryString from "query-string";

import TableFormat from "../../../partials/TableFormat";
import { rowsPerPage } from "../../../utils/setting";
import Dialog from "../../dialog";
import Loading from "../../loading";
import Snackbar from "../../snackbar";
import EditMenuItem from "./edit.js";
import { styles } from "./styles";
import InputFormat from "../../../partials/inputForm";
import PriceFormat from "../../../partials/priceFormat";
const headCells = [
  {
    key: "title",
    numeric: false,
    disablePadding: true,
    label: "menu_menuitem_tablehead_title",
  },
  {
    key: "price",
    numeric: false,
    disablePadding: false,
    label: "menu_menuitem_tablehead_price",
  },
  {
    key: "time",
    numeric: false,
    disablePadding: false,
    label: "menu_menuitem_tablehead_time",
  },
  {
    key: "action",
    numeric: false,
    disablePadding: false,
    label: "menu_menuitem_tablehead_featured",
  },
];

class ListMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      order: "asc",
      orderBy: "no",
      selected: [],
      allMenuItem: [],
      allMenuGroup: [],
      page: 0,
      pageFeatured: 0,
      rowsPerPage: rowsPerPage,
      rowsPerPageFeatured: rowsPerPage,
      message: "",
      collapse: [],
      itemType: -2,
    };
    this.desc = this.desc.bind(this);
    this.getSorting = this.getSorting.bind(this);
    this.deleteItem = this.deleteItem.bind(this);
    this.handleDialog = this.handleDialog.bind(this);
    this.closeDialog = this.closeDialog.bind(this);
    this.handleOpenCollapes = this.handleOpenCollapes.bind(this);
    this.select = 0;
    this.mTable = React.createRef();
  }
  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = "desc";

    if (this.state.orderBy === property && this.state.order === "desc") {
      order = "asc";
    }

    this.setState({ order, orderBy });
  };

  handleSelectAllClick = (event, checked) => {
    if (checked) {
      this.setState({
        selected: this.props.listMenu.map((item) => item.itemCode),
      });
    } else this.setState({ selected: [] });
  };
  async componentDidMount() {
    this.props.onRef(this);
    this.loading.startLoading();
    await this.getList();
    this.loading.stopLoading();
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.adminService !== this.props.adminService ||
      (nextProps.adminService &&
        this.props.adminService &&
        nextProps.adminService.no !== this.props.adminService.no)
    ) {
      this.getList({ serviceCode: nextProps.adminService.no });
    }
    if (nextProps.menuId !== this.props.menuId) {
      this.getList({
        id: nextProps.menuId,
      });
    }
  }
  getList = async (payload = {}) => {
    const _this = this;
    return await _this.getMenuItem(payload);
  };
  getAllMenuItem = (payload = {}) => {
    let { t, adminService = {}, role = "", menuId = [] } = this.props;
    if (
      (role !== "admin" && role !== "employeeAdmin") ||
      (adminService && adminService.no) ||
      payload.serviceCode
    ) {
      if (!payload.serviceCode) {
        payload.serviceCode = adminService.no;
      }
      this.props.serviceMenuItemDispatch.getAllMenuItem({
        id: menuId,
        ...payload,
      });
    }
  };
  getAllMenuItemFeature = (payload = {}) => {
    let { t, adminService = {}, role = "", menuId = [] } = this.props;
    if (
      (role !== "admin" && role !== "employeeAdmin") ||
      (adminService && adminService.no) ||
      payload.serviceCode
    ) {
      if (!payload.serviceCode) {
        payload.serviceCode = adminService.no;
      }
      this.props.serviceMenuItemDispatch.getAllMenuItemFeature({
        id: menuId,
        ...payload,
      });
    }
  };
  getMenuItem = async (payload = {}) => {
    let { t, adminService = {}, role = "" } = this.props;
    if (
      (role !== "admin" && role !== "employeeAdmin") ||
      (adminService && adminService.no) ||
      payload.serviceCode
    ) {
      if (!payload.serviceCode) {
        payload.serviceCode = adminService.no;
      }
      this.loading.startLoading();
      const { rowsPerPage, page } = this.state;
      const { search = "", menuId = [] } = this.props;
      let check = await this.props.serviceMenuItemDispatch.getMenuItem({
        limit: rowsPerPage,
        page: page,
        search: search,
        id: menuId,
        ...payload,
      });
      this.loading.stopLoading();
      if (check.code !== 1) this.mSnackbar.handleClick(check.message, "error");
    }
  };

  toggleFeatured = async (payload = {}) => {
    const { t, location } = this.props;
    let { search } = location;
    let check = await this.props.serviceMenuItemDispatch.changeFeatured(
      payload
    );
    if (check && check.code === 1) {
      search = queryString.parse(search);
      this.getList({
        page: search.page,
        limit: search.pageSize,
      });
      if (payload.featured)
        this.mSnackbar.handleClick(
          t("menu_menuitem_remove_item_featured_successfully")
        );
      else
        this.mSnackbar.handleClick(
          t("menu_menuitem_add_item_featured_successfully")
        );
    } else {
      if (payload.featured)
        this.mSnackbar.handleClick(
          t("menu_menuitem_remove_item_featured_unsuccessfully") +
          " " +
          check.message,
          "error"
        );
      else
        this.mSnackbar.handleClick(
          t("menu_menuitem_add_item_featured_unsuccessfully") +
          " " +
          check.message,
          "error"
        );
    }
  };
  getSorting(order, orderBy) {
    return order === "desc"
      ? (a, b) => this.desc(a, b, orderBy)
      : (a, b) => -this.desc(a, b, orderBy);
  }
  desc(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }
  isSelected = (id) => this.state.selected.indexOf(id) !== -1;
  handleClick = (event, id) => {
    const { selected } = this.state;
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    this.setState({ selected: newSelected });
  };
  deleteItem = async (selected = []) => {
    const { t } = this.props;
    let check = await this.props.serviceMenuItemDispatch.deleteMenuItem(
      selected
    );
    this.mDialog.handleDialogClose();
    if (check.code === 1) {
      this.mSnackbar.handleClick(t("menu_menuitem_delete_successfully"));
    } else {
      this.mSnackbar.handleClick(
        t("menu_menuitem_delete_unsuccessfully") + " " + check.message,
        "error"
      );
    }
    return check;
  };
  handleDialog() {
    if (this.state.selected.length) {
      this.mDialog.handleDialogOpen();
    } else this.mDialogNotSelect.handleDialogOpen();
  }
  closeDialog() {
    this.mDialogNotSelect.handleDialogClose();
  }
  handleOpenCollapes(id) {
    let { collapse = [] } = this.state;
    let allMenuItem = this.props.listMenu;
    for (let i = 0; i <= allMenuItem.length; i++) {
      if (i === id) {
        collapse[i] = !collapse[i];
      } else collapse[i] = false;
    }
    this.setState({ collapse: collapse });
  }
  finishAction = (status) => {
    let { t } = this.props;
    if (status === 1) {
      this.handleOpenCollapes(-1);
      this.mSnackbar.handleClick(
        t("menu_menuitem_editmenuitem_update_successfully")
      );
    } else {
      this.mSnackbar.handleClick(
        status || t("menu_menuitem_editmenuitem_update_unsuccessfully"),
        "error"
      );
    }
    this.getMenuItem();
  };
  actionColumn = (row = {}, index) => {
    const { t, classes } = this.props;
    return (
      <div className={classes.actionColumn}>
        <Checkbox
          checked={row.featured ? true : false}
          onChange={() => this.toggleFeatured(row)}
          value="primary"
          inputProps={{ "aria-label": "primary checkbox" }}
        />
      </div>
    );
  };
  renderCollapse = (row, index) => {
    const { collapse = [] } = this.state;
    const {
      disabled,
      featured,
      listMenu = [],
      listMenuFeatured = [],
      classes,
    } = this.props;
    const allMenuItem = featured ? listMenuFeatured : listMenu;
    return (
      <TableRow key={index}>
        <TableCell
          colSpan={headCells.length + 1}
          padding={"none"}
          className={classes.tableCellInCollapes}
        >
          <Collapse in={collapse[index]} unmountOnExit>
            <EditMenuItem
              item={index}
              data={allMenuItem.find((e) => e.itemCode === row.itemCode)}
              finishAction={this.finishAction}
              disabled={disabled}
            />
          </Collapse>
        </TableCell>
      </TableRow>
    );
  };
  handleFilter = (e) => {
    let _this = this;
    let payload = {};
    let value = e.target.value;
    if (value === -1) value = 0;
    if (value !== -2)
      payload = {
        filter: [{ featured: value }],
      };
    this.setState({ itemType: value, selected: [] }, function () {
      _this.getMenuItem(payload);
    });
  };
  render() {
    const {
      classes,
      t,
      total,
      totalFeatured,
      featured,
      listMenu = [],
      listMenuFeatured = [],
      label,
      count,
      history,
      location,
    } = this.props;
    const { collapse = [], itemType } = this.state;
    const allMenuItem = featured ? listMenuFeatured : listMenu;
    const customBtn = () => {
      return (
        <>
          <InputFormat
            select
            label={t("menu_menuitem_item_type")}
            placeholder={t("pls_select")}
            fullWidth={true}
            className={classes.customFilterInput}
            value={itemType === 0 ? -1 : itemType}
            onChange={this.handleFilter}
            name="itemType"
            InputProps={{
              className: classes.root,
            }}
            // margin="dense"
            variant="outlined"
          >
            <MenuItem value={-2}>{t("menu_menuitem_all_item")}</MenuItem>
            <MenuItem value={1}>{t("menu_menuitem_featured_item")}</MenuItem>
            <MenuItem value={-1}>
              {t("menu_menuitem_not_featured_item")}
            </MenuItem>
          </InputFormat>
          {!this.props.disabled && (
            <Button
              variant="contained"
              color="primary"
              className={classes.button}
              onClick={this.props.handleEditItem}
            >
              {t("add_menu_item")}
            </Button>
          )}
        </>
      );
    };
    return (
      <div className={classes.wrapGrid}>
        <Snackbar
          color="white"
          onRef={(snackbar) => (this.mSnackbar = snackbar)}
        />
        <Dialog
          onRef={(dialog) => (this.mDialog = dialog)}
          disagree={t("menu_menuitem_cancel")}
          agree={t("menu_menuitem_yes")}
          title={t("menu_menuitem_confirm")}
          content={t(
            "menu_menuitem_do_you_want_to_delete_this_menu_group_from_list"
          )}
          action={this.deleteItem}
        />
        <Dialog
          onRef={(dialog) => (this.mDialogNotSelect = dialog)}
          agree={t("menu_menuitem_yes")}
          title={t("menu_menuitem_nothing_item_is_selected")}
          action={this.closeDialog}
        />
        <Loading onRef={(id) => (this.loading = id)} />

        <TableFormat
          customBtn={customBtn}
          onRef={(ref) => (this.mTable = ref)}
          orderBy="title"
          contentDialog={t(
            "menu_menuitem_do_you_want_to_delete_this_menu_group_from_list"
          )}
          onDelete={this.deleteItem}
          title={label}
          showFilter={false}
          placeholder={t("menu_menuitem_search")}
          headCells={headCells}
          totalCount={featured ? totalFeatured : total}
          count={count}
          size={"medium"}
          isCollapse={true}
          collapse={collapse}
          hiddenSearch={featured ? true : false}
          renderCollapse={this.renderCollapse}
          handleOpenCollapes={this.handleOpenCollapes}
          actionColumn={this.actionColumn}
          getList={this.getList}
          history={history}
          location={location}
          rows={allMenuItem.map((row) => {
            return {
              itemCode: row.itemCode,
              id: row.itemCode,
              title: row.title,
              price: <PriceFormat value={row.price} />,
              time: `${row.itemTime} ${t("menu_menuitem_min")}`,
              featured: row.featured,
              serviceCode: row.serviceCode,
            };
          })}
        />
      </div>
    );
  }
}

ListMenu.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapState = (state) => ({
  listMenu: state.serviceMenuItem.listMenu,
  listMenuFeatured: state.serviceMenuItem.listMenuFeatured,
  total: state.serviceMenuItem.total,
  count: state.serviceMenuItem.count,
  totalFeatured: state.serviceMenuItem.totalFeatured,
  adminService: state.service.adminService || {},
  role: state.user.user.roleId.role,
  ownerCode: state.service.service.userCode,
});

const mapDispatch = (dispatch) => ({
  serviceMenuItemDispatch: dispatch.serviceMenuItem,
});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(styles, { withTheme: true })(ListMenu)));
